import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import { cityStates, cities } from "../../options";

interface AddressComponentProps {
  countryValue: number | null;
  stateValue: number | null;
  cityValue: string | null;
  addressValue: string;
  onCountryChange?: (value: number | null) => void;
  onStateChange: (state: string) => void;
  onCityChange: (city: string) => void;
  onAddressChange: (address: string) => void;
}

const AddressComponent: React.FC<AddressComponentProps> = ({
  countryValue,
  stateValue,
  cityValue,
  addressValue,
  onCountryChange,
  onStateChange,
  onCityChange,
  onAddressChange,
}) => {
  const [showStateSuggestions, setShowStateSuggestions] = useState(false);
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);

  return (
    <Formik
      initialValues={{
        state:
          cityStates.find((state) => state.value === stateValue?.toString())
            ?.label || "",
        city: cityValue || "",
        address: addressValue || "",
      }}
      onSubmit={(values) => {
        onStateChange(values.state);
        onCityChange(values.city);
        onAddressChange(values.address);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className="border shadow m-2 p-2 bg-slate-50 rounded-lg">
          <h2 className="text-lg font-medium mb-4">ادرس محل کار</h2>
          <div className="mb-4">
            <label
              htmlFor="country"
              className="block text-sm font-medium text-gray-700"
            >
              کشور
            </label>
            <Field
              type="text"
              name="country"
              value="ایران"
              readOnly
              className="mt-1 block w-full p-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-gray1"
            />
          </div>
          <div className="mb-4 relative">
            <label
              htmlFor="state"
              className="block text-sm font-medium text-gray-700"
            >
              استان
            </label>
            <Field
              name="state"
              value={values.state}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue("state", e.target.value);
                setShowStateSuggestions(true);
              }}
              onFocus={() => setShowStateSuggestions(true)}
              onBlur={() =>
                setTimeout(() => setShowStateSuggestions(false), 200)
              }
              placeholder="استان خود را انتخاب کنید"
              className="mt-1 block w-full p-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-gray1"
            />
            {showStateSuggestions && (
              <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-y-auto">
                {cityStates
                  .filter((state) =>
                    state.label
                      .toLowerCase()
                      .includes(values.state.toLowerCase())
                  )
                  .map((state) => (
                    <li
                      key={state.value}
                      onMouseDown={() => {
                        setFieldValue("state", state.label);
                        setShowStateSuggestions(false);
                        onStateChange(state.value);
                      }}
                      className="p-2 cursor-pointer hover:bg-gray-100"
                    >
                      {state.label}
                    </li>
                  ))}
              </ul>
            )}
          </div>
          <div className="mb-4 relative">
            <label
              htmlFor="city"
              className="block text-sm font-medium text-gray-700"
            >
              شهر
            </label>
            <Field
              name="city"
              value={values.city}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue("city", e.target.value);
                setShowCitySuggestions(true);
              }}
              onFocus={() => setShowCitySuggestions(true)}
              onBlur={() =>
                setTimeout(() => setShowCitySuggestions(false), 200)
              }
              placeholder="شهر خود را انتخاب کنید"
              className="mt-1 block w-full p-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-gray1"
            />
            {showCitySuggestions && stateValue && (
              <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-y-auto">
                {cities[stateValue.toString() as keyof typeof cities]
                  ?.filter((city) =>
                    city.toLowerCase().includes(values.city.toLowerCase())
                  )
                  ?.map((city, index) => (
                    <li
                      key={index}
                      onMouseDown={() => {
                        setFieldValue("city", city);
                        setShowCitySuggestions(false);
                        onCityChange(city);
                      }}
                      className="p-2 cursor-pointer hover:bg-gray-100"
                    >
                      {city}
                    </li>
                  ))}
              </ul>
            )}
          </div>
          <div>
            <label
              htmlFor="address"
              className="block text-sm font-medium text-gray-700"
            >
              آدرس
            </label>
            <Field
              name="address"
              placeholder="آدرس خود را وارد کنید"
              value={values.address}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const newValue = e.target.value;
                setFieldValue("address", newValue);
                onAddressChange(newValue);
              }}
              className="mt-1 block w-full p-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-gray1"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddressComponent;
